<div class="intro-banner placeholder-glow">
	<figure class="intro-banner-image" [class.placeholder]="loading">
		<img class="img-fluid" [ngSrc]="imageUrl" (load)="loading = false" loading="lazy" fill />
	</figure>
</div>
